import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { FileType } from '../models/bulk.models';

export const PanelStatusChanged = createAction('[Bulk Operations: Add New Configuration]: Panel Status Changed');

export const GetStatusValues = createAction(
  '[Bulk Operations: Add New Configuration]: Get Status Values',
  props<{ statusValues: string[] }>(),
);

export const GetFile = createAction('[Bulk Operations: Add New Configuration]: Get File', props<{ file: any }>());

export const FileToUploadChanged = createAction(
  '[Bulk Operations: Add New Configuration]: File To Upload Changed',
  props<{ fileToUpload: any }>(),
);

export const RemoveFile = createAction('[Bulk Operations: Add New Configuration]: Remove File');

export const FileReaderError = createAction('[Bulk Operations: Add New Configuration]: File Reader Error');

export const GetOriginalFile = createAction(
  '[Bulk Operations: Add New Configuration]: Get Original File',
  props<{ originalFile: any }>(),
);

export const GetFileTableRows = createAction(
  '[Bulk Operations: Add New Configuration]: Get File Table Rows',
  props<{ fileTableRows: any }>(),
);

export const GetDisplayedColumns = createAction(
  '[Bulk Operations: Add New Configuration]: Get Displayed Columns',
  props<{ cols: number; firstRowLength: number }>(),
);

export const GetFileTypes = createAction('[Bulk Operations: Add New Configuration]: Get FileTypes');

export const GetFileTypesSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Get File Types Success',
  props<{ res: FileType }>(),
);

export const GetFileTypesFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Get File Types Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetAttributesTypes = createAction('[Bulk Operations: Add New Configuration]: Get Attribute Types');

export const GetAttributesTypesSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Get Attribute Types Success',
  props<{ res: any }>(),
);

export const GetAttributesTypesFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Get Attribute Types Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetPersonsAttributes = createAction('[Bulk Operations: Add New Configuration]: Get Persons Attributes');

export const GetPersonsAttributesSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Get Persons Attributes Success',
  props<{ res: any }>(),
);

export const GetPersonsAttributesFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Get Persons Attributes Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetCouponsAttributes = createAction('[Bulk Operations: Add New Configuration]: Get Coupons Attributes');

export const GetCouponsAttributesSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Get Coupons Attributes Success',
  props<{ res: any }>(),
);

export const GetCouponsAttributesFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Get Coupons Attributes Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetLoyaltyMemberAttributes = createAction(
  '[Bulk Operations: Add New Configuration]: Get Loyalty Member Attributes',
);

export const GetLoyaltyMemberAttributesSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Get Loyalty Member Attributes Success',
  props<{ res: any }>(),
);

export const GetLoyaltyMemberAttributesFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Get Loyalty Member Attributes Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetFlowNames = createAction('[Bulk Operations: Add New Configuration]: Get Flow Names');

export const GetFlowNamesSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Get Flow Names Success',
  props<{ res: any }>(),
);

export const GetFlowNamesFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Get Flow Names Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const GetElements = createAction('[Bulk Operations: Add New Configuration]: Get Elements');

export const GetElementsSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Get Elements Success',
  props<{ res: any }>(),
);

export const SQLStatementChanged = createAction(
  '[Bulk Operations: Add New Configuration]: SQL Statement Changed',
  props<{ sqlStatement: string; index: number }>(),
);

export const GetElementsFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Get Elements Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const FlowNameChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Flow Name Changed',
  props<{ flowName: string }>(),
);

export const DropZoneEnabled = createAction('[Bulk Operations: Add New Configuration]: Drop Zone Enabled');

export const DropZoneDisabled = createAction('[Bulk Operations: Add New Configuration]: Drop Zone Disabled');

export const ButtonPointerEventEnabled = createAction(
  '[Bulk Operations: Add New Configuration]: Button Pointer Event Enabled',
);

export const ButtonPointerEventDisabled = createAction(
  '[Bulk Operations: Add New Configuration]: Button Pointer Event Disabled',
);

export const FileTypeChanged = createAction(
  '[Bulk Operations: Add New Configuration]: File Type Changed',
  props<{ fileType: string }>(),
);

export const UploadedFileChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Uploaded File Changed',
  props<{ name: string; size: string }>(),
);

export const FileNameChanged = createAction(
  '[Bulk Operations: Add New Configuration]: File Name Changed',
  props<{ fileName: string }>(),
);

export const ProfileModelKeyChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Profile Model Key Changed',
  props<{ profileModelKey: string }>(),
);

export const DataDelimiterChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Data Delimiter Changed',
  props<{ selectedDelimiter: string }>(),
);

export const AttributeTypeChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Attribute Type Changed',
  props<{ attributeType: string }>(),
);

export const TableAttributeTypeChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Table Attribute Type Changed',
  props<{ attributeType: string; index: number }>(),
);

export const AttributeCodeChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Attribute Code Changed',
  props<{ attributeCode: string }>(),
);

export const TableAttributeCodeChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Table Attribute Code Changed',
  props<{ attributeCode: string; index: number }>(),
);

export const TableExtraFieldCodeChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Table Extra Field Code Changed',
  props<{ extraFieldCode: string; index: number }>(),
);

export const ModelOptionChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Model Option Changed',
  props<{ selectedModelOption: string; index: number }>(),
);

export const ConfigurationNameChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Configuration Name Changed',
  props<{ configurationName: string }>(),
);

export const ConfigurationDescriptionChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Configuration Description Changed',
  props<{ configurationDescription: string }>(),
);

export const NotificationEmailChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Notification Email Changed',
  props<{ notificationEmail: string }>(),
);

export const ProfileModelChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Profile Model Changed',
  props<{ profileModel: string }>(),
);

export const ModelPropertyChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Model Property Changed',
  props<{ selectedModelProperty: string; index: number }>(),
);

export const FirstLineHeadersChanged = createAction(
  '[Bulk Operations: Add New Configuration]: First Line Headers Changed',
);

export const MappingOptionsChanged = createAction('[Bulk Operations: Add New Configuration]: Mapping Options Changed');

export const StartNewBulkOperationChanged = createAction(
  '[Bulk Operations: Add New Configuration]: Start New Bulk Operation Changed',
);

export const SaveConfiguration = createAction('[Bulk Operations: Add New Configuration]: Save Configuration');

export const SaveConfigurationSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Save Configuration Success',
  props<{ res: any }>(),
);

export const SaveConfigurationFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Save Configuration Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const ExecuteConfiguration = createAction('[Bulk Operations: Add New Configuration]: Execute Configuration');

export const ExecuteConfigurationSuccess = createAction(
  '[Bulk Operations: Add New Configuration]: Execute Configuration Success',
  props<{ res: any }>(),
);

export const ExecuteConfigurationFailed = createAction(
  '[Bulk Operations: Add New Configuration]: Execute Configuration Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const AddNewConfEditData = createAction(
  '[Bulk Operations: Add New Configuration]: Add New Conf Edit Data',
  props<{ row: any }>(),
);

export const EmptyAddNewConf = createAction('[Bulk Operations: Add New Configuration]: Empty Add New Configuration');

export const ResetToOriginalTable = createAction('[Bulk Operations: Add New Configuration]: Reset To Original Table');

export const OpenNoFileSelected = createAction('[Bulk Operations: Add New Configuration]: Open No File Selected');
